import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone:false,
  selector: 'app-text-editor-preview-dialog',
  templateUrl: './text-editor-preview-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./text-editor-preview-dialog.component.scss']
})
export class TextEditorPreviewDialogComponent {

  public closeButtonText = "Close";
  public previewData!:{from:string, email:string, replyTo:string, subject:string, body:string };

  constructor(private dialogRef: MatDialogRef<TextEditorPreviewDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: any) { 
    this.previewData = this.data;
  }

  onCloseClick() {
    this.dialogRef.close(undefined);
  }

}
